import { Heading, Separator, Stack, Text } from "@generalapplications/ui";

import { Reveal } from "@/app/common/components/composite/motion/Reveal";
import { ServiceChips } from "./ServiceChips";
import type { ServiceRecord } from "@/content/services";

export type ServiceSubsectionProps = {
  services: readonly ServiceRecord[];
  copy: string;
  ariaLabel: string;
};

// Services sit *inside* the scope section they belong to — "What We Build" on a
// capability page, "Where General Applications Can Help" on an industry page —
// rather than as a sibling section.
//
// That nesting is the argument the layer makes: the prose above states the
// scope, and these are the named, purchasable pieces of it. As a sibling
// section the two read as competing lists of the same thing; as a subsection
// the relationship is obvious without a sentence explaining it.
//
// h3 because the parent PageSection renders an h2 (SectionHeader), and heading
// order has to stay correct — see the accessibility rules in AGENTS.md.
export function ServiceSubsection({
  services,
  copy,
  ariaLabel,
}: ServiceSubsectionProps) {
  if (services.length === 0) return null;

  return (
    <Stack gap="lg">
      <Separator />
      <Reveal>
        <Stack gap="xs">
          <Heading level={3} size="lg">
            Services
          </Heading>
          <Text variant="prose">{copy}</Text>
        </Stack>
      </Reveal>
      <ServiceChips services={services} ariaLabel={ariaLabel} />
    </Stack>
  );
}
